// util.js

export const obfuscationKey = '34rdfe5656565ghhhhhh';


export const base64Encode = (str) => {
  if (typeof str !== 'string') str = str?.toString() ?? '';

  let xorResult = '';
  for (let i = 0; i < str.length; i++) {
    xorResult += String.fromCharCode(str.charCodeAt(i) ^ obfuscationKey.charCodeAt(i % obfuscationKey.length));
  }

  const utf8Bytes = new TextEncoder().encode(xorResult);
  return btoa(String.fromCharCode(...utf8Bytes));
};

export const base64Decode = (encodedStr) => {
  if (typeof encodedStr !== 'string') encodedStr = '';
  if (typeof obfuscationKey !== 'string' || obfuscationKey.length === 0) return '';

  try {
    const binaryStr = atob(encodedStr);
    const bytes = Uint8Array.from(binaryStr, char => char.charCodeAt(0));
    const xorResult = new TextDecoder().decode(bytes);

    let original = '';
    for (let i = 0; i < xorResult.length; i++) {
      original += String.fromCharCode(xorResult.charCodeAt(i) ^ obfuscationKey.charCodeAt(i % obfuscationKey.length));
    }

    return original;
  } catch (e) {
    console.error('base64Decode failed:', e);
    return '';
  }
};


// Reads userAuth cookie and decodes fields
export const getVendorAndEmailFromCookies = () => {
  const userAuth = getCookie('userAuth');
  if (userAuth) {
    const [obfuscatedEmail, vendor, obfuscatedFirstname, obfuscatedLastname, initial, folderId] = userAuth.split(':');
    const email = base64Decode(obfuscatedEmail, obfuscationKey);
    const firstname = base64Decode(obfuscatedFirstname, obfuscationKey);
    const lastname = base64Decode(obfuscatedLastname, obfuscationKey);
    return { email, vendor, firstname, lastname, initial, folderId };
  }
  return null;
};

// Reads vendorAuth cookie to get email - This is only for google
export const getEmailFromVendorCookies = () => {
  const vendorAuth = getCookie('vendorAuth');
  if (vendorAuth) {
    const email = base64Decode(vendorAuth, obfuscationKey);
    return email;
  }
  return '';
};

export const getEmailFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.email : null;
};

export const getEmailPrefixWithVendorFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? `${userAuth.vendor}-${userAuth.email}` : null;
};

export const getVendorFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.vendor : null;
};

export const getFirstNameFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.firstname : null;
};

export const getLastNameFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.lastname : null;
};

export const getInitialFromCookies = () => {
  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.initial : null;
};

export const getFolderIdFromCookies = () => {
  const folderIdFromCookie = getCookie('folderId');
  if (folderIdFromCookie) {
    return folderIdFromCookie;
  }

  const userAuth = getVendorAndEmailFromCookies();
  return userAuth ? userAuth.folderId : null;
};

export const checkJwtTokenCookieExists = () => {
  const jwtToken = getCookie('jwtToken');
  return jwtToken !== null;
};

export const isUserLoggedIn = () => {
  const jwtToken = getCookie('jwtToken');
  return jwtToken !== null;
};



